import verifyFaqs from 'src/search/utils/verifyFaqs';
import { SimpleQuestion } from 'src/common/types/common/SimpleQuestion';
import { ComponentDefinition } from '../../common/types/common/ComponentDefinition';

const extractFaqs = (component: ComponentDefinition): SimpleQuestion[] => {
  if (component.type === 'FAQContent') {
    return component.props.faqs;
  }
  if (component?.props?.children && Array.isArray(component?.props?.children)) {
    return component?.props?.children.flatMap(extractFaqs);
  }
  return [];
};

const extractFaqsFromData = (
  data: ComponentDefinition[],
  url: string,
): SimpleQuestion[] => {
  const mappedFaqs = data.flatMap(extractFaqs);
  return verifyFaqs(mappedFaqs, url);
};

export default extractFaqsFromData;
